import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService, PRODUCT_NORMALIZER, UserIdService } from '@spartacus/core';
import { BehaviorSubject, catchError, map, of, shareReplay } from 'rxjs';
import { KB_PRODUCT_URL_NORMALIZER } from 'src/app/app.module';
@Injectable({
  providedIn: 'root',
})
export class KbCheckOutService {
  cartCode;
  userId: string;
  //to maintain header state
  private _isOpen = new BehaviorSubject<boolean>(false);
  isCheckOut$ = this._isOpen.asObservable();
  //to pass the orderConfirmation code
  orderConfirmationId: string;

  finalOrderSummaryRight = new BehaviorSubject<any>('');
  activeStep = new BehaviorSubject<any>(1);
  constructor(
    private http: HttpClient,
    private occEndPointService: OccEndpointsService,
    private userIdService: UserIdService,
    private converterService: ConverterService
  ) {
    this.userIdService.getUserId().subscribe((uid) => (this.userId = uid));
  }
  //method to show and hide the footer content
  canOpen(message: boolean) {
    this._isOpen.next(message);
  }
  canNavigateToCheckOut(mergeRequired: boolean, cartId: string) {
    this.cartCode = cartId;
    return this.http.get(
      this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/checkout?mergeRequired=${mergeRequired}`)
    ).pipe(shareReplay({ bufferSize: 1, refCount: false }));
  }
  checkoutStepOne(cartco) {
    this.cartCode = cartco;
    return this.http.get(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartco}/customerinformation`)).pipe(
      map((res: any) => {
        if (res.entries) {
          res = {
            ...res,
            entries: res.entries.map((x) => {
              x.product = this.converterService.convert(x.product, PRODUCT_NORMALIZER);
              return x;
            })
          };
        }
        return res;
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }
  postApiCallForStepOne(poNumber, billingAddress) {
    return this.http.post(
      this.occEndPointService.buildUrl(
        `users/${this.userId}/carts/${this.cartCode}/selectaddress?poNumber=${poNumber}&isBillingAddress=true&selectedAddressCode=${billingAddress}`
      ),
      billingAddress
    );
  }

  checkoutStepTwo(CartCode) {
    return this.http.get(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${CartCode}/deliveryoptions`));
  }

  postApiCallForStepTwo(carrierType, OrderNotes, carrierAccNum) {
    return this.http.post(
      this.occEndPointService.buildUrl(
        `users/${this.userId}/carts/${this.cartCode}/deliverymethod?selectedCarrierType=${carrierType}&orderNote=${OrderNotes}&carrierAccountNumber=${carrierAccNum}`
      ),
      {}
    );
  }

  checkoutStepThree(cartCode) {
    return this.http.get(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartCode}/shippingaddress`));
  }

  saveNewAddress(payload, cartId) {
    return this.http.post(
      this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/createshippingaddress`),
      payload
    );
  }

  useAddress(cartId, selectedAddressCode) {
    return this.http.post(
      this.occEndPointService.buildUrl(
        `users/${this.userId}/carts/${cartId}/selectaddress?isDeliveryAddress=true&selectedAddressCode=${selectedAddressCode}`
      ),
      {}
    );
  }
  //APi Call For Order Confirmation
  orderConfirmation(orderCode) {
    //orderconfirmation
    return this.http.get(this.occEndPointService.buildUrl(`orderconfirmation/${orderCode}`)).pipe(
      map((res: any) => {
        if (res.entries) {
          res = {
            ...res,
            entries: res.entries.map((x) => {
              x.product = this.converterService.convert(x.product, PRODUCT_NORMALIZER);
              return x;
            })
          };
        }
        return res;
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }
  getReviewData(cartId) {
    return this.http.get(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/review`))
      .pipe(
        map((res: any) => {
          if (res.entries) {

            res = {
              ...res,
              entries: res.entries.map((x) => {
                x.product = this.converterService.convert(x.product, PRODUCT_NORMALIZER);
                return x;
              })
            };
          }
          return res;
        }),
        catchError((error) => {
          return of(null);
        })
      );
  }

  placeOrder(cartId) {
    return this.http.post(this.occEndPointService.buildUrl(`users/${this.userId}/carts/${cartId}/placeorder`), {});
  }
}
